import React, {type FC} from 'react';

import {type ImageExportType} from '../../util/panelExport';
import {type PanelExportRef, type PanelType} from '../../util/panelTypes';
import {usePanelContext} from '../Panel/PanelContextProvider';
import {PanelCompRedux} from '../PanelCompRedux';
import ImageExportModal from './ImageExportModal';
import * as S from './PanelImageExportModal.styles';

type PanelImageExportModalProps = {
  open?: boolean;
  type: ImageExportType;
  onClose: () => void;
  panelType: PanelType;
};

export const PanelImageExportModal: FC<PanelImageExportModalProps> = React.memo(
  ({open, type, onClose, panelType}) => {
    const panelDOMRef = React.useRef<HTMLDivElement>(null);
    const panelExportRef = React.useRef<PanelExportRef>();

    const {isReadOnly, panelRef} = usePanelContext();

    return (
      <ImageExportModal
        open={open}
        type={type}
        panelDOMRef={panelDOMRef}
        panelExportRef={panelExportRef}
        viewType={panelType}
        onClose={onClose}>
        <S.PanelContainer
          className={
            panelType.toLowerCase().replace(' ', '-') +
            '-container' +
            ' fullscreen-mode'
          }
          ref={panelDOMRef}>
          <PanelCompRedux
            exportMode
            configMode={false}
            currentHeight={320}
            panelRef={panelRef}
            dimensions={undefined as any}
            readOnly={isReadOnly}
            panelExportRef={panelExportRef}
          />
        </S.PanelContainer>
      </ImageExportModal>
    );
  }
);
